import { Component, OnInit, HostBinding, OnDestroy } from '@angular/core';
import { getCustomerConfigState, State } from '../../../redux/reducers';
import { select, Store } from '@ngrx/store';
import { map, tap } from 'rxjs/operators';
import { Change } from '../../../redux/actions/dashboard/actions-options';
import { Options } from '../../../redux/models/dashboard/options';
import { Observable, Subscription } from 'rxjs';
import { isOn } from 'feature-toggle-service';
import { customerConfig } from '@uxdf/direct-shared-lib';

@Component({
  standalone: false,
  selector: 'app-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.scss']
})
export class DashboardPageComponent implements OnInit, OnDestroy {
  @HostBinding() class = 'dashboard-page amadeus-direct-style design-factory/design-factory';
  office = '';
  dashbordWarningMessage= isOn('DASHBOARD_WARNING_MESSAGE_A');
  officeOptions$: Observable<{ label: string; value: string }[]>;
  optionsState$: Observable<Options>;
  headingYear$: Observable<string>;
  isDecisionMaker = false;
  isSnow = false;
  private customerConfigSubscription: Subscription;
  readonly dashboardMainHeadingString = $localize`:@@dashboard-page.dashboardMainHeading:Dashboard`;
  readonly dashboardWarningString = $localize`:@@dashboard-page.dashboardWarning:We're improving your dashboard performance: some data from the last months may be temporarily unavailable`;
  readonly dashboardOptionsAgenciesString = $localize`:@@dashboard-page.dashboardOptionsAgencies:Display for`;
  readonly dashboardOptionsAllAgenciesString = $localize`:@@dashboard-page.dashboardOptionsAllAgencies:All agencies`;

  constructor(private readonly store: Store<State>) {}

  updateState() {
    this.store.dispatch(new Change({ options: { agencies: this.office } }));
  }

  ngOnInit() {
    this.officeOptions$ = this.store.pipe(
      select(getCustomerConfigState),
      tap(state => (this.isDecisionMaker = state && state.customerConfig['is_decision_maker'])),
      map(
        state =>
          this.isDecisionMaker &&
          state.customerConfig['office_codes'].length > 1 &&
          [{ label: this.dashboardOptionsAllAgenciesString, value: '' }].concat(
            state.customerConfig['office_codes'].map((code: string) => ({
              label: code,
              value: code
            }))
          )
      )
    );

     this.customerConfigSubscription = this.store.pipe(
        select(customerConfig)).subscribe(response => {
            this.isSnow = response.customerConfig.is_snow;
        });
  }

  ngOnDestroy() {
    if (this.customerConfigSubscription) {
      this.customerConfigSubscription.unsubscribe();
    }
  }
}
